module.exports = __webpack_public_path__ + "img/c4.121d89f7.png";